module.exports = __webpack_public_path__ + "static/img/team-img-bg.0a3970a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color/color-2/team-img-bg.png
// module id = A/Yg
// module chunks = 36